module.exports = __webpack_public_path__ + "static/assets/2917af747c717b0242dfdfdf0435e6ae.svg";